module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer clearfix"
  }, [_c('p', {
    staticClass: "copyright float-left"
  }, [_vm._v(_vm._s(_vm.$t('footer.app-version')))]), _vm._v(" "), _c('img', {
    staticClass: "logo-image float-right",
    attrs: {
      "src": require("assets/img/logo-somfy.svg"),
      "alt": "Somfy logo"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c74a8dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Footer.vue
// module id = 290
// module chunks = 2